
import React, { Component } from 'react';
import * as terms from '../terms';
import * as t from '../translate';
import LanguageList from './LanguageList';
import AutoComplete from 'react-autocomplete';
import { browserHistory } from 'react-router'


export default class Translator extends Component {

    constructor (props) {
        let state;
        super(props);
        state = {
            srcLang: 'en',
            tgtLang: '',
            term: '',
            translatedTerm: ''
        };

        if (this.props.params.srcLang) {
            state.srcLang = this.props.params.srcLang;
        }

        if (this.props.params.tgtLang) {
            state.tgtLang = this.props.params.tgtLang;
        }

        if (this.props.params.term) {
            state.term = this.props.params.term;
            state.translatedTerm = terms.getTranslationForTerm(state.srcLang, state.tgtLang, state.term);
        }

        // set state
        this.state = state;

        this.styles = {
            item: {
                padding: '2px 6px',
                cursor: 'default'
            },

            highlightedItem: {
                color: 'white',
                background: '#d5a105',
                padding: '2px 6px',
                cursor: 'default'
            },

            menu: {
                border: 'solid 1px #ccc'
            }
        };

        this.inputProps = {
            name: "sewing term",
            id: "sewing-term",
            className: "form-control"
        };

        // bind our helper with this
        this.swapLangs = this.swapLangs.bind(this);
    }

    handleSrcLanguage(state){
        if (!state.value) {
            return;
        }
        this.setState({
            srcLang: state.value
        });
    }

    handleTargetLanguage(state){
        let translation, newState;
        if (!state.value) {
            return;
        }
        newState = {
            tgtLang: state.value
        };

        if (this.state.term){
            translation = terms.getTranslationForTerm(this.state.srcLang, state.value, this.state.term);
            if (translation){
                newState.translatedTerm = translation;
            }
        }
        this.setState(newState);
    }

    componentWillUpdate(nextProps, nextState){
        this.pushUrl(nextState);
    }

    /**
     * Looks at the current state and navigates to the correct URL
     * @return {[type]} [description]
     */
    pushUrl(nextState){
        let url;
        let urlParts = ['', this.props.interfaceLang];
        if (nextState.srcLang){
            urlParts.push(nextState.srcLang);

            if (nextState.tgtLang) {
                urlParts.push(nextState.tgtLang);
                // make sure url changes
                if (nextState.term && nextState.translatedTerm) {
                    // need to check if the state's term (what is in the box) exists in our list of terms we know
                    if (terms.termExistsForLang(nextState.term, nextState.srcLang)){
                        urlParts.push(encodeURIComponent(nextState.term));
                    }
                }
            }

        }
        url = urlParts.join('/');
        if (window.location.pathname !== url){
            browserHistory.push(url);
        }
    }

    swapLangs() {
        let newState = {};
        if (this.state.srcLang && this.state.tgtLang) {
            newState.srcLang = this.state.tgtLang;
            newState.tgtLang = this.state.srcLang;

            // swap terms if they're set too
            if (this.state.term && this.state.translatedTerm) {
                newState.term = this.state.translatedTerm;
                newState.translatedTerm = this.state.term;
            }

            this.setState(newState);
        }
    }

    render() {
        let tgtSelect, autoComp, translatedTerm, swapper;
        if (this.state.srcLang) {
            tgtSelect = <LanguageList
                label='translate to'
                interfaceLang={this.props.interfaceLang}
                parentCallback={this.handleTargetLanguage.bind(this)}
                selectLang={this.state.tgtLang} />;
        }

        if (this.state.srcLang && this.state.tgtLang) {
            autoComp = (
                <div className='form-group'>
                    <label htmlFor="sewing-term">{t.t('term', this.props.interfaceLang)}</label>
                    <AutoComplete
                        className='form-group'
                        value={this.state.term}
                        inputProps={this.inputProps}
                        wrapperStyle={{}}
                        items={terms.getTerms(this.state.srcLang)}
                        getItemValue={(item) => item.term}
                        shouldItemRender={terms.matchStateToTerm}
                        sortItems={terms.sortTerms}
                        onSelect={(term, item) => {
                                this.setState({
                                    term,
                                    translatedTerm: terms.getTranslationForIdx(this.state.tgtLang, item.key)
                                });
                            }}
                        onChange={(event, term) => {
                            //if (terms.getTerms(this.state.srcLang).indexOf(term) !== -1){
                                this.setState({ term });
                            //}
                        }}
                        renderItem={(item, isHighlighted) => (
                            <div
                                style={isHighlighted ? this.styles.highlightedItem : this.styles.item}
                                key={item.key}
                            >{item.term}</div>
                        )}
                    />
                  </div>
            )
        }

        if (this.state.translatedTerm) {
            translatedTerm = (
                <div className="translation">
                    <strong>{t.t('translated term', this.props.interfaceLang)}</strong>
                    <h2 className={'lang-'+this.state.tgtLang}>{this.state.translatedTerm}</h2>
                </div>
            );
        }

        if (this.state.srcLang && this.state.tgtLang) {
            swapper = <a onClick={this.swapLangs} className="swapper">↑↓</a>;
        }

        return (
            <main className="container">

                <LanguageList
                        label='translate from'
                        parentCallback={this.handleSrcLanguage.bind(this)}
                        interfaceLang={this.props.interfaceLang}
                        selectLang={this.state.srcLang} />

                {swapper}
                {tgtSelect}
                {autoComp}
                {translatedTerm}

                <div className="feedback">

                </div>
            </main>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Translator.js
 **/